import React from 'react';
import Header from '../Header/Header'
import './NotFound.scss'

export default function NotFound(props) {
  const {
    prismicCtx
  } = props
  
  return (
    <React.Fragment>
      <Header prismicCtx={prismicCtx}/>
      <div className='notFound__wrapper'>
        <div className='notFound__container'>
          <h1 className='notFound__title'>404</h1>
          <p className='notFound__text'>Síða fannst ekki</p>
        </div>
      </div>
    </React.Fragment>
  );
}
